import { changePassword } from 'aws-auth-lib';
import { api } from './api';
import { ensureAuthSuccess } from '../utils/access';
import { portalConfig } from '../configs/portal';
import { validateProfilePicture } from '../utils/profilePicture';

export const updateOwnProfile = async (payload, role) => {
    if (!role?.uuid || role.disabled || !portalConfig.allowedRoles.includes(role.name)) {
        throw new Error('PROFILE_ROLE_UNAVAILABLE');
    }
    return api.patch('/cheart/user', payload, {
        headers: { 'CHEART-ROLE': role.uuid }
    });
};

export const uploadOwnPicture = async (file) => {
    const validationError = validateProfilePicture(file);
    if (validationError) throw new Error(validationError);
    const data = new FormData();
    data.append('picture', file);
    const response = await api.post('/cheart/user/picture', data, {
        // Let the browser supply the multipart boundary; override the JSON default.
        headers: { 'Content-Type': null }
    });
    if (!response.data?.picture || typeof response.data.picture !== 'string') {
        throw new Error('PICTURE_UNAVAILABLE');
    }
    return response.data.picture;
};

export const changeOwnPassword = async (currentPassword, newPassword) =>
    ensureAuthSuccess(await changePassword(currentPassword, newPassword));

export const profileErrorMessage = (error) => {
    if (error?.response?.status === 401) return 'A sessão expirou. Volte a iniciar sessão.';
    if (error?.response?.status === 403) return 'Não foi possível autorizar a alteração do perfil.';
    if (error?.response?.status === 400) return 'Não foi possível guardar. Verifique os dados introduzidos.';
    return 'Não foi possível guardar os dados. Verifique a ligação e tente novamente.';
};

export const passwordErrorMessage = (error) => {
    if (error?.name === 'InvalidPasswordException') return 'A nova palavra-passe não cumpre os requisitos de segurança da conta.';
    if (error?.name === 'PasswordHistoryPolicyViolationException') return 'Escolha uma palavra-passe que não tenha utilizado recentemente.';
    if (error?.name === 'NotAuthorizedException') return 'Não foi possível confirmar a palavra-passe atual. Verifique-a ou volte a iniciar sessão.';
    if (['LimitExceededException', 'TooManyRequestsException'].includes(error?.name)) return 'Foram feitas demasiadas tentativas. Aguarde antes de tentar novamente.';
    return 'Não foi possível alterar a palavra-passe. Tente novamente.';
};
